import { render, staticRenderFns } from "./DoorCreator.vue?vue&type=template&id=1e97c5ee"
import script from "./DoorCreator.vue?vue&type=script&lang=js"
export * from "./DoorCreator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports